export const Tooltip = () => null;

Tooltip['displayName'] = 'MeterBarChart.Tooltip';
